import { useRef, useCallback, useMemo } from 'react';
import { ERROR_REQUEST_CANCLE } from '@web-mail/common/constant';
import { getIn18Text } from 'api';
export { ERROR_REQUEST_CANCLE } from '@web-mail/common/constant';
const useGetUniqReqWrap = (fn) => {
    const promiseRef = useRef();
    const promiseAbort = useRef(null);
    const getCallback = useCallback((callback) => (...params) => {
        if (promiseRef && promiseAbort.current) {
            promiseAbort && promiseAbort.current && promiseAbort.current(ERROR_REQUEST_CANCLE);
        }
        const res = callback(...params);
        if (res instanceof Promise) {
            const pr = promiseRef;
            const warpPromise = Promise.race([
                res,
                new Promise((resolve, reject) => {
                    const pab = promiseAbort;
                    pab.current = reject;
                }),
            ]);
            pr.current = res;
            return warpPromise.then(data => {
                const pab = promiseAbort;
                pab.current = null;
                return data;
            });
        }
        throw new Error(getIn18Text('HANSHUBIXUFAN'));
    }, []);
    const fnRes = useMemo(() => {
        return fn ? getCallback(fn) : () => { };
    }, [fn]);
    const fnWrap = useMemo(() => {
        return (callback) => getCallback(callback);
    }, []);
    if (fn) {
        return fnRes;
    }
    return fnWrap;
};
export default useGetUniqReqWrap;
